module.exports = __webpack_public_path__ + "img/code.51ff01ad.png";